/**
* @file 旅游包车 - 包车工单列表
* */
<template>
  <div id="charteredWork">
    <el-tabs v-model="workType" type="card" @tab-click="handleWorkTypeChange" class="work-type-tabs">
      <el-tab-pane name="tourism">
        <span slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>旅游包车</span>
        <el-radio-group v-model="tabAction" style="margin-bottom: 10px;">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button v-for="item in $const.HITCHHIKINGWORK" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-tab-pane>
      <el-tab-pane name="customize">
        <span slot="label"><i class="el-icon-s-promotion" style="margin-right:4px"></i>专线包车</span>
        <el-radio-group v-model="tabAction" style="margin-bottom: 10px;">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button v-for="item in $const.HITCHHIKINGWORK" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-tab-pane>
    </el-tabs>

    <custom-table :has-channel="true" has-organization="true" ref="customTable" :customOptions="customOptions"
      :columns="columns" labelWidth="135" style="height: 95%" :columnsSettingShow="true" @listBack="handleListBack">
      <template slot="table-operation">
        <el-table-column label="操作" width="80" fixed="right" align="center">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="actionFn({ type: 'look', row: row })">详情</el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="['serviceTime', 'latestDepartureTime', 'created', 'finishTime'].includes(item.prop)">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop === 'schedulingNo'">
          <div>
            <span class="link" @click.stop="actionFn({ type: 'look', row: row })" @dblclick="$utils.dblclickCopy">{{ row.schedulingNo }}</span>
          </div>
          <div>
            <el-tag :type="getStatusType(row.status)" size="mini">{{ row.status | filterConst('HITCHHIKINGWORK') }}</el-tag>
            <span @dblclick="$utils.dblclickCopy" style="margin-left: 4px;"> {{ row.channelName }}</span>
          </div>
        </template>
        <template v-else-if="item.prop === 'startCity'">
          <div>{{ row.startCity }} - {{ row.endCity }}</div>
          <el-tag :type="row.cityType == 1 ? 'warning' : 'success'" size="small">{{ row.cityType == 1 ? '城际' : '市内' }}线路</el-tag>
        </template>
        <template v-else-if="item.prop == 'licenseNo'">
          <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>
        <template v-else-if="item.prop === 'vehicleNo'">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
        <template v-else-if="item.prop === 'driverName'">
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
          <div @dblclick="$utils.dblclickCopy">{{ row.driverPhone }}</div>
        </template>
        <template v-else-if="item.prop == 'cityType'">
          {{ row.cityType | filterConst('HITCHHIKINGTYPE') }}
        </template>
        <template v-else-if="item.prop == 'totalAmount'">
          <span class="util-money">¥{{ row.totalAmount || 0 }}</span>
        </template>
        <template v-else-if="item.prop == 'realTotalFee'">
          <span class="util-money">¥{{ row.realTotalFee || 0 }}</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <el-drawer 
      :visible.sync="show" 
      destroy-on-close 
      :close-on-click-modal="false" 
      :before-close="handClose"
      :show-close="false"
      size="70%"
      direction="rtl">
      <orderHitchhikingWorkDetails @handClose="handClose" v-if="show" :rowData="rowData"></orderHitchhikingWorkDetails>
    </el-drawer>
  </div>
</template>

<script>
import orderHitchhikingWorkDetails from '../orderDriver/orderHitchhikingWork/components/orderHitchhikingWorkDetails.vue'
export default {
  name: "charteredWork",
  components: { orderHitchhikingWorkDetails },
  data() {
    return {
      workType: 'tourism',
      tabAction: "all",
      orgLoaded: false, // 机构列表是否加载完成
      customOptions: {
        url: "/api/v1/manage/order/driver/chartered/list",
        params: {
          page: 1,
          size: 20,
        },
        search: [
          { type: "input", field: "schedulingNo", name: "工单号", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "driverPhone", name: "司机电话", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
        ],
      },
      columns: [
        { prop: "schedulingNo", label: "行程编号", minWidth: 150 },
        { prop: "serviceTime", label: "出发时间", minWidth: 130 },
        { prop: "startCity", label: "城市/线路", minWidth: 120 },
        { prop: "startPointName", label: "上车位置", minWidth: 200 },
        { prop: "endPointName", label: "下车位置", minWidth: 200 },
        { prop: "passengerAllNum", label: "乘车人数", minWidth: 80 },
        { prop: "licenseNo", label: "车辆号牌", minWidth: 120 },
        { prop: "vehicleNo", label: "车辆编号", minWidth: 100, hide: true },
        { prop: "driverName", label: "司机信息", minWidth: 120 },
        { prop: "finishTime", label: "完成/取消时间", minWidth: 130 },
        { prop: "totalAmount", label: "总计金额", minWidth: 90 },
        { prop: "realTotalFee", label: "司机收入", minWidth: 90 },
      ],
      show: false,
      rowData: {}
    };
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = val != "all" ? val : null;
      this.$refs.customTable.listFn();
    },
  },
  methods: {
    handleListBack(data) {
      // 将 organizationId 映射为 organizationName
      if (data && this.organizations && this.organizations.length > 0) {
        data.forEach(item => {
          if (item.organizationId) {
            const org = this.organizations.find(o => o.id === item.organizationId);
            this.$set(item, 'organizationName', org ? org.name : '');
          }
        });
      }
    },
    handleWorkTypeChange() {
      this.tabAction = 'all';
      this.customOptions.params.page = 1;
      this.customOptions.params.status = null;
      if (this.workType === 'tourism') {
        this.customOptions.url = "/api/v1/manage/order/driver/chartered/list";
      } else {
        this.customOptions.url = "/api/v1/manage/order/driver/intercity/list";
      }
      this.$nextTick(() => { this.$refs.customTable.listFn(); });
    },
    getStatusType(status) {
      const item = this.$const.HITCHHIKINGWORK.find(value => value.value == status);
      return item ? item.type : 'info';
    },
    actionFn({ type, row }) {
      if (type === "look") {
        this.rowData = row;
        this.show = true;
      }
    },
    handClose() {
      this.rowData = {};
      this.show = false;
      this.$refs.customTable.listFn();
    },
  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    }
  },
  async mounted() {
    // 加载机构列表，用于映射 organizationId 到 organizationName
    await this.mixinOrganizations();
  },
};
</script>

<style scoped lang="less">
#charteredWork {
  height: 100%;

  .work-type-tabs {
    margin-bottom: 0;
    /deep/ .el-tabs__header {
      margin-bottom: 0;
    }
    /deep/ .el-tabs__content {
      padding: 10px 0 0 0;
    }
  }

  /deep/ .link {
    color: #409EFF;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  /deep/ .el-drawer {
    width: 70% !important;
    overflow-x: hidden;
    .el-drawer__body {
      padding: 0;
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>
